import TableContainerReactTable from 'Components/Common/TableContainerReactTable';
import { useMemo } from 'react';
import { Row, Col, ButtonGroup, Button } from 'reactstrap';

interface AttributeData {
  type: string;
  name: string;
  value: string;
  currentValue: string;
  measure: string;
  oldMeasure: string;
  comments: string;
  htmlComments: string;
  mandatory: boolean;
  created: string;
  createdBy: string;
}

const AttributeTab = () => {
  const handleNew = () => { };
  const handleSave = () => { };
  const handleCancel = () => { };
  const handleDelete = () => { };

  const data: AttributeData[] = [];

  const columns = useMemo(
    () => [
      { header: 'Type', accessorKey: 'type', size: 80, enableColumnFilter: false },
      { header: 'Name', accessorKey: 'name', size: 120, enableColumnFilter: false },
      { header: 'Value', accessorKey: 'value', size: 100, enableColumnFilter: false },
      { header: 'Current Value', accessorKey: 'currentValue', size: 120, enableColumnFilter: false },
      { header: 'Measure', accessorKey: 'measure', size: 100, enableColumnFilter: false },
      { header: 'Old Measure', accessorKey: 'oldMeasure', size: 100, enableColumnFilter: false },
      { header: 'Comments', accessorKey: 'comments', size: 120, enableColumnFilter: false },
      { header: 'HTML Comments', accessorKey: 'htmlComments', size: 120, enableColumnFilter: false },
      {
        header: 'Mandatory',
        accessorKey: 'mandatory',
        size: 80,
        enableColumnFilter: false,
        cell: (cell: any) => cell.getValue() ? (
          <div className="text-center"><i className="ri-checkbox-circle-line fs-17 align-middle"></i></div>
        ) : null,
      },
      { header: 'Created', accessorKey: 'created', size: 100, enableColumnFilter: false },
      { header: 'Created By', accessorKey: 'createdBy', size: 100, enableColumnFilter: false },
    ],
    []
  );

  return (
    <div className="page-content p-0">
      <Row className="mb-3">
        <Col>
          <ButtonGroup className='gap-2'>
            <button onClick={handleNew} className="d-inline-flex align-items-center btn btn-soft-primary btn-sm">
              <i className="ri-add-line align-middle me-1"></i> New
            </button>
            <button onClick={handleSave} className="d-inline-flex align-items-center btn btn-soft-success btn-sm">
              <i className="ri-save-line align-middle me-1"></i> Save
            </button>
            <button onClick={handleCancel} className="d-inline-flex align-items-center btn btn-soft-warning btn-sm">
              <i className="ri-close-line align-middle me-1"></i> Cancel
            </button>
            <button onClick={handleDelete} className="d-inline-flex align-items-center btn btn-soft-danger btn-sm">
              <i className="ri-delete-bin-line align-middle me-1"></i> Delete
            </button>
          </ButtonGroup>
        </Col>
      </Row>
      <div className="attribute-content">
        <TableContainerReactTable
          columns={columns}
          data={data}
          divClass="table-responsive"
          tableClass="align-middle table-nowrap"
          theadClass="table-light"
          verticalLines={true}
        />
      </div>
    </div>
  );
};

export default AttributeTab; 